module.exports = __webpack_public_path__ + "img/wecom_qr.f17b8cac.png";